import "./globalCapabilityServices.css";
import staffingImage from "../../../assets/home/s5.webp";
import kpoImage from "../../../assets/home/s6.webp";
import botImage from "../../../assets/home/s7.webp";
import bpoImage from "../../../assets/home/s8.webp";

const services = [
  {
    number: "01",
    title: "Build-Operate-Transfer (BOT) / Lean GCC",
    description:
      "Establish and develop an operation with structured support, with the option to transition it to your organization.",
    href: "/global-capability/bot-lean-gcc",
    image: botImage,
    imageAlt: "Modern office environment for business operations",
    imagePosition: "center",
  },
  {
    number: "02",
    title: "Knowledge Process Outsourcing (KPO)",
    description:
      "Support specialized, knowledge-intensive processes with people and workflows tailored to your operational needs.",
    href: "/global-capability/kpo",
    image: kpoImage,
    imageAlt: "Business professionals reviewing information and reports",
    imagePosition: "center",
  },
  {
    number: "03",
    title: "Business Process Outsourcing (BPO)",
    description:
      "Delegate agreed business processes to a delivery partner so your internal team can focus on core priorities.",
    href: "/global-capability/bpo",
    image: bpoImage,
    imageAlt: "Contemporary professional workspace",
    imagePosition: "center",
  },
  {
    number: "04",
    title: "Dedicated Staffing",
    description:
      "Extend your team with professionals aligned to your roles, workflows, and business requirements.",
    href: "/global-capability/dedicated-staffing",
    image: staffingImage,
    imageAlt: "Professionals collaborating in a modern workspace",
    imagePosition: "center",
  },
];

const GlobalCapabilityServices = () => {
  return (
    <section className="gc-services" id="gc-services">
      <div className="gc-services__container">
        <div className="gc-services__header">
          <div className="gc-services__heading-group">
            <span className="gc-services__eyebrow">
              <span className="gc-services__eyebrow-dot" />
              OUR SERVICE MODELS
            </span>

            <h2 className="gc-services__title">
              The Right Support.
              <br />
              <span>Built Around Your Business.</span>
            </h2>
          </div>

          <p className="gc-services__intro">
            Explore our service models to find the right fit for your team,
            workflows, and operational goals.
          </p>
        </div>
        <div className="gc-services__grid">
          {services.map((service) => (
            <a
              key={service.number}
              href={service.href}
              className="gc-service-card"
              aria-label={`Explore ${service.title}`}
            >
              <div className="gc-service-card__media">
                <img
                  src={service.image}
                  alt={service.imageAlt}
                  className="gc-service-card__image"
                  loading="lazy"
                  decoding="async"
                  style={{ objectPosition: service.imagePosition }}
                />

                <div
                  className="gc-service-card__overlay"
                  aria-hidden="true"
                />

                <span className="gc-service-card__number">
                  {service.number}
                </span>

                <span
                  className="gc-service-card__arrow"
                  aria-hidden="true"
                >
                  ↗
                </span>

                <div className="gc-service-card__content">
                  <span className="gc-service-card__category">
                    GLOBAL CAPABILITY SERVICES
                  </span>

                  <h3 className="gc-service-card__title">
                    {service.title}
                  </h3>

                  <p className="gc-service-card__description">
                    {service.description}
                  </p>

                  <span className="gc-service-card__link">
                    Explore Service
                    <span aria-hidden="true">→</span>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalCapabilityServices;